module.exports = __webpack_public_path__ + "static/media/inconnect.6e580723.svg";